import { render, staticRenderFns } from "./SinglePic.vue?vue&type=template&id=7d08e7fc&scoped=true&"
import script from "./SinglePic.vue?vue&type=script&lang=ts&"
export * from "./SinglePic.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePic.vue?vue&type=style&index=0&id=7d08e7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08e7fc",
  null
  
)

export default component.exports